import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import MasterBrokerAddForm from "./MasterBrokerAddForm";

const MasterBrokerAdd = ({ buttonConfig, isButtonClicked }) => {
  const schema = z.object({
    name: z.string().nonempty("Name is required."),
    short_name: z.string(),
    broker_logo: z.instanceof(FileList),
    broker_api: z.string(),
    status: z.boolean().or(z.string()),
    eff_start_date: z.string().nonempty(),
    // eff_end_date: z.string().nullable(),
    address_line_1: z.string().nonempty(),
    address_line_2: z.string(),
    address_line_3: z.string().or(z.undefined()),
    city: z.string().nonempty("City name is required."),
    state: z.string().nonempty("State name is required."),
    pin_code: z.string().nonempty("Pincode name is required."),
  });

  const form = useForm({
    defaultValues: {
      status: "true",
      address_line_3: "",
      // eff_end_date: null,
    },
    resolver: zodResolver(schema),
  });

  return (
    <MasterBrokerAddForm
      form={form}
      segmentName={buttonConfig.name}
      addHandler={buttonConfig.addHandler}
      closeHandler={buttonConfig.closeAddModal}
      isButtonClicked={isButtonClicked}
    />
  );
};

export default MasterBrokerAdd;
